import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartCount: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartCount: (state, action) => {
      state.cartCount = action.payload;
    },
    incrementCartCount: (state) => {
      state.cartCount += 1;
    },
    decrementCartCount: (state) => {
      if (state.cartCount > 0) {
        state.cartCount -= 1;
      }
    },
     setCartDetails: (state, action) => {
      state.cart = action.payload;
    },
  },
});

export const { setCartCount, incrementCartCount, decrementCartCount, setCartDetails } = cartSlice.actions; // Corrected line
export default cartSlice.reducer;